export default __webpack_public_path__ + "img/ejTOhLIJ.ba24c4ec.svg";